"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12.625 8.983a.7.7 0 0 1-.682.718 2.3 2.3 0 0 0-1.57.673A2.3 2.3 0 0 0 9.7 12a.7.7 0 0 1-1.4 0c0-.946.361-1.893 1.083-2.615a3.69 3.69 0 0 1 2.525-1.084.7.7 0 0 1 .717.682M15 11.3a.7.7 0 0 1 .7.7 3.694 3.694 0 0 1-3.654 3.7.7.7 0 0 1-.017-1.4A2.294 2.294 0 0 0 14.3 12a.7.7 0 0 1 .7-.7",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12 6.2c-3.158 0-5.988 1.715-7.26 4.33-.225.464-.34.965-.34 1.47 0 .504.115 1.005.34 1.47a7.2 7.2 0 0 0 1.04 1.572.7.7 0 1 1-1.059.916 8.6 8.6 0 0 1-1.24-1.877A4.76 4.76 0 0 1 3 12c0-.72.165-1.43.482-2.082C5.005 6.782 8.35 4.8 12 4.8a9.98 9.98 0 0 1 3.07.482.7.7 0 1 1-.431 1.332A8.6 8.6 0 0 0 12 6.2m6.291 1.77a.7.7 0 0 1 .988.072 8.696 8.696 0 0 1 1.24 1.876A4.76 4.76 0 0 1 21 12c0 .72-.165 1.429-.482 2.081C18.995 17.217 15.65 19.2 12 19.2a10 10 0 0 1-2.985-.456.7.7 0 0 1 .419-1.335 8.6 8.6 0 0 0 2.566.39c3.158 0 5.988-1.714 7.26-4.33A3.36 3.36 0 0 0 19.6 12a3.36 3.36 0 0 0-.34-1.469 7.2 7.2 0 0 0-1.04-1.572.7.7 0 0 1 .071-.987",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M20.495 3.505a.7.7 0 0 1 0 .99l-16 16a.7.7 0 0 1-.99-.99l16-16a.7.7 0 0 1 .99 0",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=EyeHideIcon24.js.map